import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/global.css'; // Assuming this is your global styles
import App from './components/App';
import { AuthProvider } from './hooks/useAuth'; // Import your AuthProvider
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider as MuiThemeProvider, createTheme } from '@mui/material/styles'; // MUI ThemeProvider
import * as serviceWorker from './serviceWorker'; // Reverted to original service worker import
import { setupApiInterceptor } from './utils/apiInterceptor';
// import reportWebVitals from './reportWebVitals'; // Optional

// Setup API interceptor for session timeout handling
setupApiInterceptor();

// MUI Theme (from user's version)
const theme = createTheme({
  typography: {
    fontFamily: "'Poppins', sans-serif",
  },
  palette: {
    primary: {
      main: '#2c3e50',
    },
    secondary: {
      main: '#3498db',
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <MuiThemeProvider theme={theme}> {/* MUI ThemeProvider wraps everything inside Router */}
        <AuthProvider> {/* Your AuthProvider wraps App */}
          <App />
        </AuthProvider>
      </MuiThemeProvider>
    </Router>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorker.unregister(); // Disabled service worker to fix MIME type error


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
